const store = {};
const getItem = (key) => {
  return store[key];
};
const removeItem = (key) => {
  delete store[key];
};
const setItem = (key, value) => {
  store[key] = value;
};
export {
  getItem,
  removeItem,
  setItem
};
//# sourceMappingURL=requestStorage.js.map
